<div class="container-fluid">
    <div class="row budgetAudit">           
        <div class="budgetAuditInner" fxLayout="column" fxLayoutAlign="center center">
            <div class="budgetAuditContent" fxFlexFill [fxLayout]="iLayout" [fxLayoutAlign]="iLayout === 'row' ? 'space-between start' : 'center center'">
                <div class="budgetDate">
                    <div class="" style="padding: 18px 18px 0 18px;">
                        <h3 style="text-align: center;">{{ 'BUDGET_AUDIT' | translate }}</h3>
                        <div [formGroup]="budgetForm">
                            <div>
                                <div class="formGroup dateSelect">
                                    <div class="form dropdown">
                                        <select class="form-select mb-2" [attr.aria-label]="'PLEASE_SELECT_PERIOD' | translate" formControlName="key" (change)="onReportPeriodChange($any($event.target).value)">
                                            <option value="" disabled>{{ 'PLEASE_SELECT_PERIOD' | translate }}</option>
                                            <option *ngFor="let p of reportPeriods" [value]="p.key">
                                                {{ (p.key || '') | translate }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="dateRange">
                                        <div class="form dateInput">
                                            <label class="sr-only" for="startDate">{{ 'START' | translate }}</label>
                                            <input type="month" formControlName="startDate"
                                            class="form-control form-date date-custom" [ngClass]="{ 'is-invalid': budgetForm.controls.startDate.errors }" />
                                            <div *ngIf="budgetForm.controls.startDate.errors" class="invalid-feedback">
                                            <div *ngIf="budgetForm.controls.startDate.errors.required">{{ 'PLEASE_SELECT_PERIOD' | translate }}</div>
                                            </div>
                                        </div>
                
                                        <div class="form dateInput dateDash">
                                            <span style="margin: 0 6px;">&mdash;</span>
                                        </div>
                
                                        <div class="form dateInput">
                                            <label class="sr-only" for="stopDate">{{ 'END' | translate }}</label>
                                            <input type="month" formControlName="stopDate"
                                            class="form-control form-date date-custom" [ngClass]="{ 'is-invalid': budgetForm.controls.stopDate.errors }" />
                                            <div *ngIf="budgetForm.controls.stopDate.errors" class="invalid-feedback">
                                            <div *ngIf="budgetForm.controls.stopDate.errors.required">{{ 'PLEASE_SELECT_PERIOD' | translate }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="formGroup">
                                    <div class="form submit">
                                        <button type="button" class="btn btn-primary mb-2" (click)="submitBudgetForm()">{{ 'UPDATE' | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="budgetTable" fxFlex>
                    <app-report-datatable 
                    [iSortColumn]="'monthYear'"
                    [iSortDirection]="'desc'"
                    [iColumns]="visibleBudgetColumns" 
                    [iData$]="aggregateData"
                    [iTotalCount]="aggregateData.length"
                    [iTotalData]="budgetTotals"
                    [iShowHeader]="false"
                    [iShowFooter]="false"
                    [iPageSize]="100"
                    [iShowSearch]="false"
                    [iShowPagination]="false"
                    [iReportTitle]="'BUDGET_AUDIT_BY_MONTH' | translate"
                    >
                    </app-report-datatable>

                    <div *ngIf="budgetTotals.cost > 0" class="budgetTotals">
                        <div class="budgetTotal">
                            <div class="budgetTotalLabel">{{ 'TOTAL_PAID' | translate }}</div>
                            <div class="budgetTotalValue">{{ budgetTotals.totalPrice | currency:'USD' }}</div>
                        </div>
                        <div class="budgetTotal">
                            <div class="budgetTotalLabel">{{ 'TOTAL_SPENT' | translate }}</div>
                            <div class="budgetTotalValue">{{ budgetTotals.cost | currency:'USD' }}</div>
                        </div>
                        <div class="budgetTotal">
                            <div class="budgetTotalLabel">{{ 'TOTAL_DIFFERENCE' | translate }}</div>
                            <div class="budgetTotalValue">{{ budgetTotals.netAmount | currency:'USD' }}</div>
                        </div>
                        <div class="budgetTotal">
                            <div class="budgetTotalLabel">{{ 'TOTAL_PERCENT_DIFFERENCE' | translate }}</div>
                            <div class="budgetTotalValue">{{ budgetTotals.percentDifference | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
